module.exports = __webpack_public_path__ + "img/wapintr@2x.c09737a1.png";